import {
  Fragment,
  Suspense,
  lazy,
} from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import LoadingScreen from 'components/Loaders/LoadingScreen';
import PermissionGuard from 'components/PermissionGuard';

import authenticationRoutes from './authentication';
import dashboardRoutes from './dashboard';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const redirect = () => <Redirect to="/terminals" />;

const landingRoutes = {
  path: '*',
  routes: [error404],
};

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, index) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Permission = route.permission
            ? PermissionGuard
            : Fragment;
          // `Fragment` sólo acepta `key` y `children`: pasarle `permission`
          // dispara un warning de React. Sólo se propaga la prop cuando el
          // wrapper es PermissionGuard.
          const permissionProps = route.permission
            ? { permission: route.permission }
            : {};

          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes
                      ? (renderRoutes(route.routes))
                      : (<Permission {...permissionProps}>
                        <Component {...props} />
                      </Permission>)}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense >
  ) : null;

function Routes() {
  return renderRoutes([
    {
      exact: true,
      path: '/',
      component: redirect,
    },
    authenticationRoutes,
    dashboardRoutes,
    landingRoutes,
    error404,
  ]);
}

export default Routes;
